var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main HomePage when User Lands With Website Address",
    clipPath: "url(#clip0_1232_1748)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    transform: "translate(-1215 -406)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Profile Information",
    filter: "url(#filter0_d_1232_1748)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: -306,
    width: 390,
    height: 345,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 427320609"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 427320445"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 427320439"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.70593 6.76995C8.5189 6.76995 8.33954 6.69565 8.20729 6.56341C8.07505 6.43116 8.00075 6.2518 8.00075 6.06477V3.94923C8.00075 3.38815 7.77786 2.85006 7.38112 2.45332C6.98438 2.05657 6.44628 1.83369 5.88521 1.83369H4.13918C3.57811 1.83369 3.04001 2.05657 2.64327 2.45332C2.24653 2.85006 2.02364 3.38815 2.02364 3.94923V13.8218C2.02364 14.3828 2.24653 14.9209 2.64327 15.3177C3.04001 15.7144 3.57811 15.9373 4.13918 15.9373H5.88521C6.44628 15.9373 6.98438 15.7144 7.38112 15.3177C7.77786 14.9209 8.00075 14.3828 8.00075 13.8218V11.7062C8.00075 11.5192 8.07505 11.3398 8.20729 11.2076C8.33954 11.0753 8.5189 11.001 8.70593 11.001C8.89295 11.001 9.07232 11.0753 9.20457 11.2076C9.33681 11.3398 9.41111 11.5192 9.41111 11.7062V13.8218C9.40999 14.7565 9.03815 15.6527 8.37716 16.3137C7.71617 16.9747 6.81999 17.3465 5.88521 17.3477H4.13918C3.2044 17.3465 2.30822 16.9747 1.64723 16.3137C0.986238 15.6527 0.614401 14.7565 0.613281 13.8218L0.613281 3.94923C0.614401 3.01445 0.986238 2.11827 1.64723 1.45728C2.30822 0.796284 3.2044 0.424448 4.13918 0.423328H5.88521C6.81999 0.424448 7.71617 0.796284 8.37716 1.45728C9.03815 2.11827 9.40999 3.01445 9.41111 3.94923V6.06477C9.41111 6.2518 9.33681 6.43116 9.20457 6.56341C9.07232 6.69565 8.89295 6.76995 8.70593 6.76995Z",
    fill: "#FF5755"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.7386 10.3811L13.5047 13.615C13.4396 13.6824 13.3618 13.7361 13.2758 13.7731C13.1897 13.81 13.0972 13.8295 13.0036 13.8303C12.9099 13.8311 12.8171 13.8133 12.7304 13.7778C12.6437 13.7424 12.565 13.69 12.4988 13.6238C12.4326 13.5576 12.3802 13.4788 12.3448 13.3922C12.3093 13.3055 12.2915 13.2126 12.2923 13.119C12.2931 13.0254 12.3125 12.9328 12.3495 12.8468C12.3865 12.7608 12.4402 12.683 12.5075 12.6179L15.513 9.61173L4.84434 9.59058C4.65732 9.59058 4.47795 9.51628 4.3457 9.38403C4.21346 9.25179 4.13916 9.07242 4.13916 8.8854C4.13916 8.69837 4.21346 8.519 4.3457 8.38676C4.47795 8.25451 4.65732 8.18021 4.84434 8.18021L15.5546 8.20208L12.5061 5.15288C12.4388 5.08783 12.385 5.01001 12.3481 4.92398C12.3111 4.83794 12.2917 4.74541 12.2909 4.65178C12.2901 4.55814 12.3079 4.46529 12.3434 4.37862C12.3788 4.29196 12.4312 4.21322 12.4974 4.14701C12.5636 4.0808 12.6423 4.02844 12.729 3.99298C12.8157 3.95752 12.9085 3.93968 13.0021 3.94049C13.0958 3.94131 13.1883 3.96076 13.2744 3.99772C13.3604 4.03468 13.4382 4.0884 13.5032 4.15575L16.7372 7.38971C17.134 7.78624 17.357 8.32414 17.3573 8.8851C17.3576 9.44607 17.135 9.98417 16.7386 10.3811Z",
    fill: "#FF5755"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1232_1748",
    x: -49,
    y: -330,
    width: 438,
    height: 393,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1232_1748"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1232_1748",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1232_1748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white",
    transform: "translate(-1215 -406)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.a07f47184e0b7a49c98e3bfabf543aed.svg";
export { ForwardRef as ReactComponent };